// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"8438c276","245":"3f3b75ef","369":"215226ed","382":"f2b180c5","574":"bd24035a","578":"8af1c3f1","640":"f67f684d","823":"9707b883"}[chunkId] + ".chunk.js";
};